import React from "react";
import { Query, QueryProps, QueryResult } from "react-apollo";
import {
  AdminInsightsProductInfo,
  EventDetailsInfo,
  InsightsProduct,
  AdminSharedInsightsProductInfo,
  SharedInsightsDetailsInfo,
  SharedInsightsProduct,
} from "../../fragments/product";
import gql from "graphql-tag";

const productQuery = gql`
  query adminInsightsProduct($id: String!) {
    product: adminInsightsProduct(id: $id) {
      ... on AdminInsightsProduct {
        ...AdminInsightsProductInfo
        eventDetails {
          ...EventDetailsInfo
        }
      }
      ... on AdminSharedInsightsProduct {
        ...AdminSharedInsightsProductInfo
        details {
          ...SharedInsightsDetailsInfo
        }
      }
    }
  }
  ${AdminInsightsProductInfo}
  ${EventDetailsInfo}
  ${AdminSharedInsightsProductInfo}
  ${SharedInsightsDetailsInfo}
`;

interface ProductQueryResult {
  product: InsightsProduct | SharedInsightsProduct | null;
}

interface ProductQueryProps
  extends Omit<
    QueryProps<ProductQueryResult>,
    "query" | "variables" | "fetchPolicy"
  > {
  id: string;
}

const ProductQuery: React.FC<ProductQueryProps> = (props) => {
  const { children, id } = props;
  return (
    <Query query={productQuery} variables={{ id }} fetchPolicy="network-only">
      {(queryResult: QueryResult<ProductQueryResult>) => {
        return children(queryResult);
      }}
    </Query>
  );
};

export default ProductQuery;
